import { Injectable } from '@angular/core';
import { SavedSearch } from 'src/app/models/advanced-search-extended-models/saved-search/saved-search';

@Injectable({
    providedIn: 'root'
  })
  export class SavedSearchStore {

    userSavedSearch: SavedSearch[];
    predefinedSearch: SavedSearch[];

    constructor() {
    }

    load(records: SavedSearch[]) {
        this.userSavedSearch = records.filter(r => !r.isDefaultSearch);
        this.predefinedSearch = records.filter(r => r.isDefaultSearch);
    }
}
